export type CCASubdomain =
  | 'Abstract Reasoning'
  | 'Logical Reasoning'
  | 'Quantitative Aptitude'
  | 'Verbal Ability'
  | 'Data Interpretation';

export const CCA_SUBDOMAINS: CCASubdomain[] = [
  'Abstract Reasoning',
  'Logical Reasoning',
  'Quantitative Aptitude',
  'Verbal Ability',
  'Data Interpretation',
];

export const CCA_LEVEL_LABELS: Record<number, string> = {
  1: 'Sub-school',
  2: 'Sub-school',
  3: 'School',
  4: 'School',
  5: 'Early Tertiary',
  6: 'Graduate',
  7: 'Professional',
  8: 'Senior Professional',
  9: 'Advanced / Specialist',
  10: 'Elite / Strategic',
};

export const SubdomainBadgeColors: Record<CCASubdomain, string> = {
  'Abstract Reasoning': 'bg-violet-100 text-violet-700',
  'Logical Reasoning': 'bg-blue-100 text-blue-700',
  'Quantitative Aptitude': 'bg-emerald-100 text-emerald-700',
  'Verbal Ability': 'bg-amber-100 text-amber-700',
  'Data Interpretation': 'bg-rose-100 text-rose-700',
};

export const LevelBadgeColors: Record<number, string> = {
  1: 'bg-slate-100 text-slate-600',
  2: 'bg-slate-100 text-slate-600',
  3: 'bg-sky-100 text-sky-700',
  4: 'bg-sky-100 text-sky-700',
  5: 'bg-blue-100 text-blue-700',
  6: 'bg-indigo-100 text-indigo-700',
  7: 'bg-violet-100 text-violet-700',
  8: 'bg-purple-100 text-purple-700',
  9: 'bg-fuchsia-100 text-fuchsia-700',
  10: 'bg-rose-100 text-rose-700',
};

export const PAGE_SIZE = 25;
